<template>
  <nav class="breadcrumb-nav" aria-label="Breadcrumb">
    <router-link :to="{ name: 'en-gb' }">Home</router-link>
    <span v-for="item in normalizedItems" :key="item.label" class="breadcrumb-item">
      <span class="breadcrumb-separator" aria-hidden="true">/</span>
      <router-link v-if="item.to" :to="item.to">{{ item.label }}</router-link>
      <span v-else>{{ item.label }}</span>
    </span>
  </nav>
</template>

<script>
export default {
  name: 'BreadcrumbNav',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    normalizedItems() {
      return this.items.filter((item) => item && item.label)
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-nav {
  width: min(1600px, calc(100% - 200px));
  min-height: 56px;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: #60746b;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 13px;
  line-height: 1.4;
  text-transform: uppercase;
}

.breadcrumb-nav a {
  color: #0f8f43;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.breadcrumb-separator {
  color: #9ab5a6;
}

@media (max-width: 820px) {
  .breadcrumb-nav {
    width: min(1120px, calc(100% - 32px));
    min-height: 48px;
  }
}
</style>
